import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const ACTS_Mass = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='ACTS_Mass' className='file-pdf-document'>
            <div className='file-template'>  




<table>
    <tr>
        <td className='w-150'><span className='eleHeader'>Type of Support</span></td>
        <td className='w-350'><span className="eleHeader">Question to Ask Caregiver</span></td>
        <td className='w-250'><span className="eleHeader">Person(s) identified</span></td>
    </tr>
    <tr>
        <td className='w-150'>Instrumental </td>
        <td className='w-350'>Instrumental If you needed a ride or car, who would you ask?</td>
        <td className='w-250'>
            <input type="text" id="txtPersonIdentified_1" name="txtPersonIdentified_1" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-150'>&nbsp;</td>
        <td className='w-350'>If you needed to borrow money, who would you ask?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_2" name="txtPersonIdentified_2" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-150'>&nbsp;</td>
        <td className='w-350'>If you needed someone to watch the kids, who would you ask? </td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_3" name="txtPersonIdentified_3" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-150'>&nbsp;</td>
        <td className='w-350'>If you needed food or clothing, who would you call?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_4" name="txtPersonIdentified_4" className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-150'>Emotional</td>
        <td className='w-350'>If you needed someone to listen, who would you call?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_5" name="txtPersonIdentified_5" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-150'>&nbsp; </td>
        <td className='w-350'>Who would you call in an emergency with the kids?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_6" name="txtPersonIdentified_6" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-150'>&nbsp; </td>
        <td className='w-350'>Who would you go to for a shoulder to cry on?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_7" name="txtPersonIdentified_7" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-150'>&nbsp; </td>
        <td className='w-350'>With whom do you share good  news?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_8" name="txtPersonIdentified_8" className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-150'>Appraisal</td>
        <td className='w-350'>If you needed a second opinion about parenting, who would you ask?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_9" name="txtPersonIdentified_9" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-150'>&nbsp; </td>
        <td className='w-350'>Whose opinion do you value?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_10" name="txtPersonIdentified_10" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-150'>&nbsp; </td>
        <td className='w-350'>Who has given you good advice?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_11" name="txtPersonIdentified_11" className='add-only' /></td>
    </tr>

    <tr>
        <td className='w-150'>Informational</td>
        <td className='w-350'>If you needed information about something at the school or in the neighborhood, whom would you ask?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_12" name="txtPersonIdentified_12" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-150'>&nbsp; </td>
        <td className='w-350'>Where can you find out about kids activities?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_13" name="txtPersonIdentified_13" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-150'>&nbsp; </td>
        <td className='w-350'>Who can tell you where to go for financial help?</td>
        <td className='w-250'>
            <input  type="text" id="txtPersonIdentified_14" name="txtPersonIdentified_14" className='add-only' /></td>
    </tr>
</table>

<table>
    <tr>
        <td className='w-250'><span className="eleHeader">Support Person</span></td>
        <td className='w-250'><span className="eleHeader">Special Competencies </span></td>
        <td className='w-250'><span className="eleHeader">Limitations</span></td>
    </tr>
    <tr>
        <td className='w-250'>
            <input  type="text" id="txtSupportPerson" name="txtSupportPerson" className='add-only' /></td>
        <td className='w-250'>
            <input  type="text" id="txtSpecialCompetencies" name="txtSpecialCompetencies" className='add-only' /></td>
        <td className='w-250'>
            <input  type="text" id="txtLimitations" name="txtLimitations" className='add-only' /></td>
    </tr>
</table>

<p>
    <center><b>Social Support Cost Benefit Analysis</b></center>
</p>


<table>
    <tr>
        <td className='w-125'><span className="eleHeader">Specific Need&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></td>
        <td className='w-125'><span className="eleHeader">Possible matching Person</span></td>
        <td className='w-125'><span className="eleHeader">Pros of selecting this person</span></td>
        <td className='w-125'><span className="eleHeader">Cons of selecting this person</span></td>
        <td className='w-125'><span className="eleHeader">Possible  reciprocal help for this person</span></td>
        <td className='w-125'><span className="eleHeader">Difficulty of selecting this person (1-10)</span></td>
    </tr>
    <tr>
        <td className='w-125'>
            <input  type="text" id="txtSpecific_1" name="txtSpecific_1" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossible_1" name="txtPossible_1" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtProsOfSe_1" name="txtProsOfSe_1" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtConsOfSe_1" name="txtConsOfSe_1" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossiRec_1" name="txtPossiRec_1" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtDifficul_1" name="txtDifficul_1" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-125'>
            <input  type="text" id="txtSpecific_2" name="txtSpecific_2" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossible_2" name="txtPossible_2" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtProsOfSe_2" name="txtProsOfSe_2" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtConsOfSe_2" name="txtConsOfSe_2" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossiRec_2" name="txtPossiRec_2" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtDifficul_2" name="txtDifficul_2" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-125'>
            <input  type="text" id="txtSpecific_3" name="txtSpecific_3" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossible_3" name="txtPossible_3" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtProsOfSe_3" name="txtProsOfSe_3" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtConsOfSe_3" name="txtConsOfSe_3" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossiRec_3" name="txtPossiRec_3" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtDifficul_3" name="txtDifficul_3" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-125'>
            <input  type="text" id="txtSpecific_4" name="txtSpecific_4" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossible_4" name="txtPossible_4" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtProsOfSe_4" name="txtProsOfSe_4" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtConsOfSe_4" name="txtConsOfSe_4" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossiRec_4" name="txtPossiRec_4" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtDifficul_4" name="txtDifficul_4" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-125'>
            <input  type="text" id="txtSpecific_5" name="txtSpecific_5" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossible_5" name="txtPossible_5" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtProsOfSe_5" name="txtProsOfSe_5" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtConsOfSe_5" name="txtConsOfSe_5" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossiRec_5" name="txtPossiRec_5" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtDifficul_5" name="txtDifficul_5" className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-125'>
            <input  type="text" id="txtSpecific_6" name="txtSpecific_6" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossible_6" name="txtPossible_6" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtProsOfSe_6" name="txtProsOfSe_6" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtConsOfSe_6" name="txtConsOfSe_6" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtPossiRec_6" name="txtPossiRec_6" className='add-only' /></td>
        <td className='w-125'>
            <input  type="text" id="txtDifficul_6" name="txtDifficul_6" className='add-only' /></td>
    </tr>
</table> 




            </div>
        </form>

    )
}  
